import {
  canSendContractForSignature,
  getSendForSignatureTooltip,
} from '@pages/Admin/Reports/ContractReport/utils/sendForSignature.utils'
import { StudentContractDock } from './studentContracts.types'
import {
  ComplianceRequiredDocument,
  getRequiredDocumentFileIds,
} from '@/helpers/new/requiredDocumentsCompliance.utils'

export { canSendContractForSignature, getSendForSignatureTooltip }

export const buildStudentContractDocks = (
  student?: {
    contracts?: Array<Omit<StudentContractDock, 'typeDocument'>>
    documents?: Array<Omit<StudentContractDock, 'typeDocument'>>
    documents_compliance?: {
      required_documents?: ComplianceRequiredDocument[]
    } | null
  },
): StudentContractDock[] => {
  const contracts = (student?.contracts ?? []).map((contract) => ({
    ...contract,
    typeDocument: 'contract' as const,
  }))

  const requiredFileIds = getRequiredDocumentFileIds(
    student?.documents_compliance?.required_documents ?? [],
  )
  const documents = (student?.documents ?? [])
    .filter((item) => !requiredFileIds.has(Number(item?.id)))
    .filter((item) => Number(item?.is_approved) === 1)
    .map((document) => ({
      ...document,
      typeDocument: 'document' as const,
    }))

  return [...contracts, ...documents].sort(
    (a, b) => Number(b?.created_at ?? 0) - Number(a?.created_at ?? 0),
  )
}
